import React from 'react'
import './Marquee.css'



const Marquee = () => {
  const departments = [
    { name: "Department of Zoology", link: "/Projectawarded" },
    { name: "Department of English", link: "/Projectawarded"},
    { name: "Department of Biochemistry", link: "/Projectawarded" },
    { name: "Department of BioInformatics and Computer Science", link: "/Projectawarded"},
    { name: "Department of Chemistry", link: "/Projectawarded" },
    { name: "Department of History", link:"/Projectawarded" },
    { name: "Department of Law", link: "/Projectawarded"},
    { name: "Department of Psychology", link: "/Projectawarded" },
    { name: "Department of Economics", link: "/Projectawarded" },
    { name: "Department of Urdu", link:"/Projectawarded" },
    { name: "Department of Political Science", link: "/Projectawarded"},
    { name: "Department of Islamiyat", link: "/Projectawarded" },
    { name: "Department of Statistic", link: "/Projectawarded" }
  ]; 

  return (
    <>
    <div className="marquee-container container ">
      <h1>Project Awarded</h1>
      <div className="marquee">
        <div className="marquee-content">
          {departments.map((department, index) => (
            <a key={index} href={department.link} className="marquee-link">
              {department.name}
            </a>
          ))}
        </div>
      </div>
    </div>



    </>
  )
}

export default Marquee
